import React from 'react';
import { Table, Tooltip, Button, Form, Input } from 'antd';
import { FORMAT_5DECIMALS } from '../../../../common/types/regularExpresionType';
import { SOLES, DOLARES_AMERICANOS } from '../../../../common/types/monedaType';
import '../styles.css';

export default function DetalleVentaTipoPrecioVenta(props) {
    return (
        <Table
            size="small"
            style={{ overflowX: 'auto' }}
            rowKey={m => m.id}
            dataSource={props.source}
            className={'table-detalle-venta-tipo-precio-venta'}
            pagination={{
                pageSize: 10,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
            columns={[
                {
                    key: 'options',
                    align: 'center',
                    width: "70px",
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    style={{ display: (row.edit ? 'none' : '') }}
                                    onClick={() => {
                                       props.onEdit(row.id, props.form);}
                                    }
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Guardar"}>
                                <Button
                                    type="primary"
                                    icon="save"
                                    size={"small"}
                                    style={{ display: (row.edit ? '' : 'none') }}
                                    onClick={() => props.onSave(row.id)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Cancelar"}>
                                <Button
                                    icon="close"
                                    size={"small"}
                                    style={{ display: (row.edit ? '' : 'none') }}
                                    onClick={() => props.onEdit(0, null)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Código',
                    dataIndex: 'codigoReferenciaProducto',
                    key: 'codigoReferenciaProducto'
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombreProducto',
                    key: 'nombreProducto'
                },
                {
                    title: 'Tipo Producto',
                    dataIndex: 'nombreTipoProducto',
                    key: 'nombreTipoProducto'
                },
                
                {
                    title: '',
                    dataIndex: 'idTipoProducto',
                    className:'hide',
                    key: 'idTipoProducto',
                    render: (value, row) => {
                        return (
                            <div>
                                {props.onGetFieldDecorator(`arrIdTipoProducto[${"IdTipoProducto" + row.id}]`, { initialValue: value })(
                                    <Input/>
                                )}
                            </div>
                        );
                    }
                },
                    {
                        title: 'Valor Unitario Soles',
                        dataIndex: 'valorUnitarioSoles',
                        key: 'valorUnitarioSoles',
                        className: props.onGetFieldValue('idMoneda') === SOLES ? '' : 'column-total',
                        align: 'right',
                        render: (value, row) => {
                            if (row.editValorUnitarioSoles)
                                return (
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrValorUnitarioSoles[${"LP" + row.id}]`, {
                                            initialValue: parseFloat(value).toFixed(5),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_5DECIMALS),
                                                message: "Formato (0.00000)"
                                            }]
                                        })(
                                            <Input
                                                placeholder="Valor Unitario Soles"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                                onKeyUp={(e) => props.onSave(row.id, e)}
                                            />
                                        )}
                                    </Form.Item>
                                );

                            return (<span>{value.toFixed(5)}</span>);
                        }
                    },
                    {
                        title: 'Precio Unitario Soles',
                        dataIndex: 'precioUnitarioSoles',
                        key: 'precioUnitarioSoles',
                        className: props.onGetFieldValue('idMoneda') === SOLES ? '' : 'column-total',
                        align: 'right',
                        render: (value, row) => {
                            if (row.editPrecioUnitarioSoles)
                                return (
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrPrecioUnitarioSoles[${"LP" + row.id}]`, {
                                            initialValue: parseFloat(value).toFixed(5),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_5DECIMALS),
                                                message: "Formato (0.00000)"
                                            }]
                                        })(
                                            <Input
                                                placeholder="Precio Unitario"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                                onKeyUp={(e) => props.onSave(row.id, e)}
                                            />
                                        )}
                                    </Form.Item>
                                );

                            return (<span>{value.toFixed(5)}</span>);
                        }
                    },
                    {
                        title: 'Valor Unitario Dólares',
                        dataIndex: 'valorUnitarioDolares',
                        key: 'valorUnitarioDolares',
                        className: props.onGetFieldValue('idMoneda') === DOLARES_AMERICANOS ? '' : 'column-total',
                        align: 'right',
                        render: (value, row) => {
                            if (row.editValorUnitarioDolares)
                                return (
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrValorUnitarioDolares[${"LP" + row.id}]`, {
                                            initialValue: parseFloat(value).toFixed(5),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_5DECIMALS),
                                                message: "Formato (0.00000)"
                                            }]
                                        })(
                                            <Input
                                                placeholder="Valor Unitario Dólares"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                                onKeyUp={(e) => props.onSave(row.id, e)}
                                            />
                                        )}
                                    </Form.Item>
                                );

                            return (<span>{value.toFixed(5)}</span>);
                        }
                    },
                    {
                        title: 'Precio Unitario Dólares' ,
                        dataIndex: 'precioUnitarioDolares',
                        key: 'precioUnitarioDolares',
                        className: props.onGetFieldValue('idMoneda') === DOLARES_AMERICANOS ? '' : 'column-total',
                        align: 'right',
                        render: (value, row) => {
                            if (row.editPrecioUnitarioDolares)
                                return (
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrPrecioUnitarioDolares[${"LP" + row.id}]`, {
                                            initialValue: parseFloat(value).toFixed(5),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_5DECIMALS),
                                                message: "Formato (0.00000)"
                                            }]
                                        })(
                                            <Input
                                                placeholder="Precio Unitario"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                                onKeyUp={(e) => props.onSave(row.id, e)}
                                            />
                                        )}
                                    </Form.Item>
                                );

                            return (<span>{value.toFixed(5)}</span>);
                        }
                    }
            ]}
        />
    );
}